export default __webpack_public_path__ + "a7e60bb258abaaac3768d770e0e28451.svg";